"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pictogram = void 0;
var _versionMap = _interopRequireDefault(require("@cbhq/cds-illustrations/__generated__/pictogram/data/versionMap"));
var _createIllustration = require("./createIllustration");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Pictogram = (0, _createIllustration.createIllustration)('pictogram', _versionMap.default);
exports.Pictogram = Pictogram;